import { render } from "./OrderCreatePage.vue?vue&type=template&id=0b588c24&scoped=true"
import script from "./OrderCreatePage.vue?vue&type=script&lang=js"
export * from "./OrderCreatePage.vue?vue&type=script&lang=js"

import "./OrderCreatePage.vue?vue&type=style&index=0&id=0b588c24&scoped=true&lang=css"

import exportComponent from "../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-0b588c24"]])

export default __exports__